<template>
  <div id="app">
    <v-app>
      <v-navigation-drawer
        v-model="drawer"
        fixed
        clipped
        :style="`margin-top: ${$vuetify.application.top}px`"
        temporary
        width="200"
      >
        <!-- app
        overlay-color="red"
        overlay-opacity="50%" -->
        <!--&& mySelf.roles.includes('admin')"-->
        <v-list class="pt-3">
          <v-list-item class="pt-2" v-on:click="$router.push('home')">
            <v-list-item-action>
              <v-icon medium color="blue">mdi-calendar</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                $t("Reservierung")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="item in items"
            :key="item.title"
            v-on:click="
              drawer = false;
              pushRoute(item);
            "
            class="pt-2"
          >
            <v-list-item-action>
              <v-icon medium :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                $t(item.title)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="pt-2" v-if="mySelf" v-on:click="logout()">
            <v-list-item-action>
              <v-icon medium>mdi-logout</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                $t("Logout")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="pt-2"
            v-if="!mySelf"
            v-on:click="$router.push('login')"
          >
            <v-list-item-action>
              <v-icon medium color="orange">mdi-key-variant</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                $t("Login")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="pt-2"
            v-if="!mySelf"
            v-on:click="$router.push('/sign-up')"
          >
            <v-list-item-action>
              <v-icon medium color="green">mdi-account-plus</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                $t("Sign Up")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="pt-2">
            <v-list-item-content>
              <v-list-item-title class="caption text-capitalize"
                >ATUS Kalsdorf Web<br />Version {{ version }}<br />2021 Schwarzl
                IT</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-card>
        <v-app-bar clipped-left fixed app color="primary">
          <!--<v-icon color="black" v-on:click="drawer = !drawer">menu</v-icon> -->
          <v-row justify="space-between">
            <v-col
              align-self="center"
              align="start"
              cols="auto"
              class="pa-0 ma-0 ml-2"
            >
              <v-btn large icon class="ml-0" v-on:click="drawer = !drawer">
                <v-icon color="white">mdi-menu</v-icon>
              </v-btn>
            </v-col>
            <v-col
              align-self="center"
              align="center"
              cols="auto"
              class="pa-4 mt-1"
            >
              <!--<v-toolbar-title class="white--text text-capitalize" >{{$t($route.name)}}</v-toolbar-title>-->
              <v-toolbar-title class="white--text text-capitalize h5"
                >ATUS Kalsdorf Web</v-toolbar-title
              >
            </v-col>
            <v-col
              align-self="center"
              align="end"
              cols="auto"
              v-if="!mySelf"
              class="pa-0 ma-0"
            >
              <v-btn small icon :to="{ name: 'login' }" class="pr-8">
                <v-icon right color="white">mdi-key-variant</v-icon>
              </v-btn>

              <v-btn small icon :to="{ name: 'signUp' }" class="pr-8">
                <v-icon color="white">mdi-account-plus</v-icon>
              </v-btn>
            </v-col>
            <!--<v-col cols="1" align="left" v-if="!mySelf">
              <v-btn small icon :to="{ name: 'signUp' }">
                <v-icon color="white">mdi-account-plus</v-icon>
              </v-btn>
            </v-col>-->
            <v-col
              align-self="center"
              align="center"
              cols="1"
              v-else-if="mySelf.firstname"
              class="pa-0 ma-0"
            >
              <div class="text-white caption">
                <v-btn small icon v-on:click="logout()" class="text-white pr-8">
                  {{ mySelf.firstname.substring(0, 1) }}.{{
                    mySelf.lastname.substring(0, 1)
                  }}.
                  <v-icon color="white">mdi-logout</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-app-bar>

        <v-main>
          <router-view></router-view>
        </v-main>
      </v-card>
      <!--
      <v-card v-if="!mySelf" color="black">
        <v-row row pb-2 pt-3>
          <v-col xs12 pl-1 ml-1 pr-1 mr-1>
            <v-card class="card--flex-toolbar">
              <v-app-bar flat color="primary">
                <v-spacer></v-spacer>

                <v-toolbar-title class="white--text text-capitalize h3">ATUS Kalsdorf Tennis Web</v-toolbar-title>
                <v-spacer></v-spacer>
                <p class="caption" align="right">Schwarzl IT 2020</p>
              </v-app-bar>
              <v-progress-linear
                color="blue"
                :active="loading"
                :height="5"
                class="ma-0"
                indeterminate
              ></v-progress-linear>
              <v-img class="white--text align-start" width="100%" src="/tennis-1.jpg">
                <router-view></router-view>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      -->
    </v-app>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "App",
  data() {
    return {
      drawer: false,
      items: [],
      //mini: true,
      right: null,
      theme1: undefined,
      version: "1.3.6",
    };
  },
  mounted() {
    this.theme1 = JSON.stringify(this.$vuetify.theme.themes);
  },
  computed: {
    ...mapState({
      status: ({ user }) => user.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
    }),
  },
  watch: {
    mySelf() {
      this.items = [];
      try {
        if (this.mySelf.roles.includes("user")) {
        }
        if (this.mySelf.roles.includes("admin")) {
          this.$router.options.routes.forEach((route) => {
            if (!_.isUndefined(route.icon)) {
              this.items.push({
                title: route.name,
                icon: route.icon,
                color: route.color,
                path: route.path,
              });
            }
          });
        }
      } catch {}
    },
  },
  methods: {
    ...mapActions("auth", ["getMySelf", "logout"]),

    pushRoute(item) {
      let item_path = item.path;
      item_path = item_path.slice(1, item.path.length);
      //this.mini = true
      //this.drawer = false
      this.$router.push(item_path);
    },
    actualRoute(path) {
      let getRoute = _.find(this.items, { path });
      if (_.isUndefined(getRoute)) {
        getRoute = {
          color: "",
          icon: "",
          name: "",
        };
      }
      return getRoute;
    },
  },
};
</script>

<style lang='scss'>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";

.card--flex-toolbar {
  margin-top: 0px;
  margin-bottom: 0px;
}

.body {
  //overscroll-behavior-y: contain !important;
  //overflow-y: hidden !important; // override Vuetify's default style
}

.html {
  //overscroll-behavior-y: contain !important;
  //overflow-y: hidden !important; // override Vuetify's default style
}
body {
  //overscroll-behavior-y: contain !important;
  //overflow-y: hidden !important; // override Vuetify's default style
}
html {
  //overscroll-behavior-y: contain !important;
  //overflow-y: hidden !important; // override Vuetify's default style
}

#app {
  overflow-x: hidden;
  height: 100%;
  background-color: #ffffff;
}
</style>